export enum Gallery2CssClassEnum {
  /**
   * Gallery item default class
   */
  itemClass = 'gallery__item',
}
